





































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";
import { SheetBase, SheetGroup, RoomName, Student, Curriculum } from "../../modules/teacher/CbtSheetEdit"

export interface Data {
  sheet_group_key: string
  tabNo: number
  sheetBase: SheetBase
  sheetGroups: SheetGroup[]
  errors: string[]
  isNew: boolean
  roomNameItems: RoomName[]
  roomNames: string[]
  students: Student[]
  selectedIdx: number
  curriculums: Curriculum[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sheet_group_key: "",
      tabNo: 1,
      sheetBase: new SheetBase(),
      sheetGroups: new Array<SheetGroup>(),
      errors: new Array<string>(),
      isNew: false,
      roomNameItems: new Array<RoomName>(),
      roomNames: new Array<string>(),
      students: new Array<Student>(),
      selectedIdx: 0,
      curriculums: new Array<Curriculum>(),
    });

    /******************************
     * 学年プルダウン変更イベント
     ******************************/

    const gradeChanged = () => {

      // 既に受験済み生徒がいる場合は確認メッセージ。キャンセルの場合は元の学年に戻す
      if(state.sheetGroups.filter(x => x.is_exists_test_started_examinees).length > 0
          && !confirm("既にテストを受験している生徒がいます。学年を変更すると、登録済みの受験者情報がクリアされますが、よろしいでしょうか？")){
        state.sheetBase.grade = state.sheetBase.grade_cache;
        return;
      }

      // クラス情報プルダウン情報を学年に紐づくクラスリストに変更
      state.roomNames = state.roomNameItems.filter(x => x.grade == Number(state.sheetBase.grade)).map(x => x.room_name);

      // クラス情報をクリア
      state.sheetGroups = new Array<SheetGroup>();
      state.sheetGroups.push(new SheetGroup());

      state.sheetBase.grade_cache = state.sheetBase.grade;
    };

    /******************************
     * クラス一覧のレコード押下
     * 選択中のクラス情報切り替え
     ******************************/

    const sheetGroupRowClick = (idx: number) => {
      state.selectedIdx = idx;
    };

    /******************************
     * クラス一覧のプラスアイコン押下
     ******************************/

    const addSheetGroup = () => {
      state.sheetGroups.push(new SheetGroup());
    }

    /******************************
     * クラス一覧のマイナスアイコン押下
     ******************************/

    const deleteSheetGroup = (sheetGroup: SheetGroup) => {
      if(sheetGroup.is_exists_test_started_examinees && !confirm("既にテストを受験している生徒がいます。削除してもよろしいでしょうか？")){
        return;
      }
      state.sheetGroups = state.sheetGroups.filter(x => x != sheetGroup);
      state.selectedIdx = 0;
    };

    /******************************
     * 全生徒受験ボタン押下
     ******************************/

    const studentsSelectAll = () => {
      if(state.sheetBase.grade == ""){
        alert("学年を選択してください。");
        return;
      }

      if(state.students.filter(x => x.grade == Number(state.sheetBase.grade)).length == 0){
        alert("現在選択している学年に生徒が存在しません。");
        return;
      }

      state.sheetGroups = new Array<SheetGroup>();
      for(let roomName of state.roomNames){
        const sheetGroup = new SheetGroup();
        sheetGroup.room_name = roomName;
        sheetGroup.students = state.students.filter(x => x.grade == Number(state.sheetBase.grade) && x.room_name == sheetGroup.room_name);
      
        // 受験者選択状態全員選択済みで初期化
        const is_selectedes = [];
        for(let student of sheetGroup.students){
          is_selectedes.push(true);
        }
        sheetGroup.is_selectedes = is_selectedes;
        sheetGroup.is_all_checked = false;

        state.sheetGroups.push(sheetGroup);
      }
    };

    /******************************
     * クラスプルダウン変更イベント
     ******************************/

    const roomNameChanged = (sheetGroup: SheetGroup) => {
      if(sheetGroup.is_exists_test_started_examinees && !confirm("既にテストを受験している生徒がいます。クラスを変更すると、登録済みの受験者情報がクリアされますが、よろしいでしょうか？")){
        sheetGroup.room_name = sheetGroup.room_name_cache;
        return;
      }

      // クラス情報配下の生徒情報を選択したクラスに紐づく生徒に洗い替え
      sheetGroup.students = state.students.filter(x => x.grade == Number(state.sheetBase.grade) && x.room_name == sheetGroup.room_name);
      
      // 受験者選択状態初期化
      const is_selectedes: boolean[] = [];
      for(const student of sheetGroup.students){
        is_selectedes.push(false);
      }
      sheetGroup.is_selectedes = is_selectedes;
      sheetGroup.is_all_checked = false;

      sheetGroup.room_name_cache = sheetGroup.room_name;
      sheetGroup.is_exists_test_started_examinees = false;
    };

    /******************************
     * 生徒一覧の生徒チェックボックス変更イベント
     ******************************/

    const examineeChanged = (student: Student, studentIdx: number) => {
      if(!state.sheetGroups[state.selectedIdx].is_selectedes[studentIdx] && student.is_test_started
        && !confirm("既に受験している生徒が存在します。選択を外して更新すると、受験者情報がクリアされますが、よろしいでしょうか？")){
        state.sheetGroups[state.selectedIdx].is_selectedes[studentIdx] = true;
        return;
      }
    };

    /******************************
     * 生徒一覧ヘッダーの選択チェックボックス変更イベント
     ******************************/

    const checkAll = () => {
      const changeVal = !state.sheetGroups[state.selectedIdx].is_all_checked;
      
      if(!changeVal && state.sheetGroups[state.selectedIdx].students.filter(x => x.is_test_started).length > 0
        && !confirm("既に受験している生徒が存在します。選択を外して更新すると、受験者情報がクリアされますが、よろしいでしょうか？")){
        return;
      }

      for(let i = 0; i < state.sheetGroups[state.selectedIdx].is_selectedes.length; i++){
        state.sheetGroups[state.selectedIdx].is_selectedes[i] = changeVal;
      }
    };

    /******************************
     * 登録前のデータチェック
     ******************************/

    const validate = () => {
      state.errors = new Array<string>();

      if (state.sheetBase.exec_date === "") {
        state.errors.push("実施日が入力されていません。");
      }
      if (state.sheetBase.name === "") {
        state.errors.push("試験名が入力されていません。");
      }
      if (state.sheetBase.curriculum_id === "") {
        state.errors.push("教科が選択されていません。");
      }
      if (state.sheetBase.grade === "") {
        state.errors.push("学年が選択されていません。");
      }
      for(let i = 0; i < state.sheetGroups.length; i++){
        if(state.sheetGroups[i].room_name == ""){
          state.errors.push(`クラス情報${i + 1}行目のクラス名が選択されていません。`);
        }else if(state.sheetGroups[i].is_selectedes.filter(x => x).length == 0){
          state.errors.push(`クラス情報${i + 1}行目の受験者が選択されていません。`);
        }
      }

      return state.errors.length == 0;
    };

    /******************************
     * 新規登録API
     ******************************/

    const createClick = async () => {
      if (!validate() || !window.confirm('試験を追加しますか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/cbt_sheet_edit`, {sheet_base: state.sheetBase, sheet_groups: state.sheetGroups}).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 更新API
     ******************************/

    const updateClick = async () => {
      if (!validate() || !window.confirm('試験を更新しますか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/cbt_sheet_edit/update/${state.sheet_group_key}`, {sheet_base: state.sheetBase, sheet_groups: state.sheetGroups}).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 削除API
     ******************************/

    const deleteClick = async () => {
      if(!window.confirm("試験を削除します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.delete(`/api/teacher/cbt_sheet_edit/${state.sheet_group_key}`).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      state.sheet_group_key = context.root.$route.params.sheet_group_key;
      state.isNew = context.root.$route.path.indexOf("new") != -1;
      let url = "";
      if(state.isNew){
        url = `/api/teacher/cbt_sheet_edit/new`;
      }else{
        url = `/api/teacher/cbt_sheet_edit/edit?sheet_group_key=${state.sheet_group_key}`;
      }
      await http.get(url).then(response => {
        
        response.data.room_name_hashes.forEach((x: any) => {
          state.roomNameItems.push(new RoomName(x.grade, x.room_name));
        });
        
        response.data.students.forEach((x: any) => {
          state.students.push(new Student(x.grade, x.room_name, x.student_no, x.student_no_character, x.name));
        });

        state.curriculums = response.data.curriculums.map((x: any) => new Curriculum(x));

        if(state.isNew){
          state.sheetGroups.push(new SheetGroup());
        }else{
          
          state.sheetBase.grade = response.data.sheets[0].grade;
          state.sheetBase.grade_cache = response.data.sheets[0].grade;
          state.sheetBase.name = response.data.sheets[0].name;
          state.sheetBase.curriculum_id = response.data.sheets[0].curriculum_id;
          state.sheetBase.subject_name = response.data.sheets[0].subject_name;
          state.sheetBase.exec_date = moment(response.data.sheets[0].exec_date).format('YYYY-MM-DD');
          state.sheetBase.grade = response.data.sheets[0].grade;
          state.sheetBase.is_sort_answer_image_enable = response.data.sheets[0].is_sort_answer_image_enable;

          response.data.sheets.forEach((sheet: any) => {
            let sheetGroup = new SheetGroup();
            sheetGroup.sheet_id = sheet.id;
            sheetGroup.room_name = sheet.room_name;
            sheetGroup.room_name_cache = sheet.room_name;
            sheetGroup.is_exists_test_started_examinees = sheet.is_exists_test_started_examinees;
            sheetGroup.students = state.students.filter(x => x.grade == Number(state.sheetBase.grade) && x.room_name == sheetGroup.room_name);

            const student_no_characters: string[] = sheet.examinees.map((x: any) => x.student_no_character);
            sheetGroup.students.forEach(student => {
              sheetGroup.is_selectedes.push(student_no_characters.filter(x => x == student.student_no_character).length > 0);
              student.is_test_started = sheet.examinees.filter((examinee: any) => examinee.student_no_character == student.student_no_character && examinee.test_started_at != null).length > 0;
            });
            state.sheetGroups.push(sheetGroup);

            state.roomNames = state.roomNameItems.filter(x => x.grade == Number(state.sheetBase.grade)).map(x => x.room_name);
          });
        }
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        window.history.back();
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      gradeChanged,
      sheetGroupRowClick,
      deleteSheetGroup,
      addSheetGroup,
      studentsSelectAll,
      roomNameChanged,
      examineeChanged,
      checkAll,
      createClick,
      updateClick,
      deleteClick,
    };
  }
})
